import { Dispatch } from "redux";

import { iPeriod, iVault, iWeb3Provider, pool, iPriceGainInfo, iBalances, iClientInfo, transactionStatus } from "../../common/interfaces/interfaces";
import { modalsActionTypes } from "../modals/modalsTypes";
import { appActionTypes } from "./appTypes";
import { store } from "../store";
import { Session } from "@chromia/ft4";
import { iChrParams } from "../../common/interfaces/chromiaInterfaces";

export function setClientAddr(addr: string | null) {
    return (dispatch: Dispatch) => {
        dispatch({ 
            type: appActionTypes.SET_CLIENT_ADDR,
            payload: addr
        })
    }
}

export function setVault(vault: pool | null) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_VAULT,
            payload: vault
        })
    }
}

export function setParams(params: iChrParams) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_PARAMS,
            payload: params
        })
    }
}

export function setWeb3Provider(provider: iWeb3Provider) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_WEB3_PROVIDER,
            payload: provider
        })
    }
}

export function setPeriods(periods: iPeriod[]) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_PERIODS,
            payload: periods
        })
    }
}

export function setVaults(vaults: iVault[]) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_VAULTS,
            payload: vaults
        })
    }
}

export function setClosedPeriod(value: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_CLOSED_PERIOD,
            payload: value
        })
    }
}

export function setPool(value: pool | null) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_POOL,
            payload: value
        })
    }
}

export function setClientInfo(clientInfo: iClientInfo | null) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_CLIENT_INFO,
            payload: clientInfo
        })
    }
}

export function setLTVault(vault: iVault) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_LT_VAULT,
            payload: vault
        })
    }
}

export function setSTVault(vault: iVault) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_ST_VAULT,
            payload: vault
        })
    }
}

export function setFtoken(fTokenName: string) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_FT_TOKEN,
            payload: fTokenName
        })
    }
}

export function setPriceGainInfo(info: iPriceGainInfo) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_PRICE_GAIN_INFO,
            payload: info
        })
    }
}

export function setAccessToken(token: string) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_ACCESS_TOKEN,
            payload: token
        })
    }
}


export function clearAppState() {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.CLEAR_APP_STATE
        })
    }
}

export const setSession = (session: Session | null) => {
	return (dispatch: Dispatch) => {
		dispatch({
			type: appActionTypes.SET_SESSION,
			payload: session
		})
	}
}

export const setChrClientAddr = (addr: string | null) => {
	return (dispatch: Dispatch) => {
		dispatch({
			type: appActionTypes.SET_CHR_CLIENT_ADDR,
			payload: addr
		})
	}
}

export const setBalances = (balances: iBalances) => {
    return (dispatch: Dispatch) => {
        dispatch({
			type: appActionTypes.SET_BALANCES,
			payload: balances
		})
    }
}

export function setTransactionStatus(status : transactionStatus) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_TRANSACTION_STATUS,
            payload: status
        })
    }
}

export function setIsIniting(isIniting: boolean) {
    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.SET_IS_INITING,
            payload: isIniting
        })
    }
}

export function disconnectApp() {
    const provider = store.getState().app.provider;
    localStorage.removeItem('WEB3_CONNECT_CACHED_PROVIDER');
    if (localStorage.getItem('walletconnect') && provider && provider.disconnect){
        provider.disconnect();
    }

    return (dispatch: Dispatch) => {
        dispatch({
            type: appActionTypes.CLEAR_APP_STATE,
        });
        dispatch({
            type: modalsActionTypes.CLEAR_MODALS_STATE
        })
    }
} 

